// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KQ-z","hovered":"LQ-z","hoverImage":"MQ-z","mainImage":"NQ-z","imageNoBackground":"OQ-z","fullSizeImage":"PQ-z"};